import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useGetSasToken = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("storage/sas");
    }, {
        ...options,
        onSuccess: (data: any, variables: any, context: any) => {
            if (data?.statusCode === 200 && data?.data) {
                options?.onSuccess?.(data, variables, context);
                return;
            }
            // Azure Blob Storage isn't configured/reachable (e.g. local dev) -- report
            // it through onError so callers gating other logic on this call settling
            // (success or failure) aren't left hanging forever.
            options?.onError?.(new Error(data?.statusMessage || "Failed to fetch storage access token."), variables, context);
        }
    });
}